var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertStatusAgileOr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 484,
    height: 140,
    viewBox: "0 0 484 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3686_27150",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 484,
    height: 140
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(42px)",
      clipPath: "url(#bgblur_0_3686_27150_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 84,
    d: "M0.199951 5C0.199951 2.23857 2.43853 0 5.19995 0H478.2C480.961 0 483.2 2.23858 483.2 5V135C483.2 137.761 480.961 140 478.2 140H5.19995C2.43852 140 0.199951 137.761 0.199951 135V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3686_27150)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 457.674,
    cy: 109.819,
    r: 81.5754,
    transform: "rotate(-67.4327 457.674 109.819)",
    fill: "#E2BEE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_3686_27150",
    maskUnits: "userSpaceOnUse",
    x: 349.078,
    y: 1.36043,
    width: 144.044,
    height: 186.677,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 349.078,
    y: 1.36043,
    width: 144.044,
    height: 186.677
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.017 176.367C428.32 180.451 423.609 182.42 419.715 180.324C403.52 171.605 390.739 157.525 383.658 140.374C375.554 120.743 375.58 98.6979 383.73 79.0867C391.881 59.4756 407.488 43.9053 427.118 35.8012C444.269 28.7204 463.265 27.8461 480.869 33.1744C485.102 34.4555 487.029 39.1838 485.332 43.2676C483.635 47.3514 478.955 49.2331 474.692 48.0582C461.045 44.2976 446.452 45.1455 433.229 50.6044C417.525 57.0877 405.039 69.5439 398.519 85.2328C391.999 100.922 391.978 118.558 398.462 134.262C403.921 147.485 413.614 158.426 425.906 165.446C429.747 167.639 431.714 172.283 430.017 176.367Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M430.017 176.367C428.32 180.451 423.609 182.42 419.715 180.324C403.52 171.605 390.739 157.525 383.658 140.374C375.554 120.743 375.58 98.6979 383.73 79.0867C391.881 59.4756 407.488 43.9053 427.118 35.8012C444.269 28.7204 463.265 27.8461 480.869 33.1744C485.102 34.4555 487.029 39.1838 485.332 43.2676C483.635 47.3514 478.955 49.2331 474.692 48.0582C461.045 44.2976 446.452 45.1455 433.229 50.6044C417.525 57.0877 405.039 69.5439 398.519 85.2328C391.999 100.922 391.978 118.558 398.462 134.262C403.921 147.485 413.614 158.426 425.906 165.446C429.747 167.639 431.714 172.283 430.017 176.367Z",
    fill: "#E2BEE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.017 176.367C428.32 180.451 423.609 182.42 419.715 180.324C403.52 171.605 390.739 157.525 383.658 140.374C375.554 120.743 375.58 98.6979 383.73 79.0867C391.881 59.4756 407.488 43.9053 427.118 35.8012C444.269 28.7204 463.265 27.8461 480.869 33.1744C485.102 34.4555 487.029 39.1838 485.332 43.2676C483.635 47.3514 478.955 49.2331 474.692 48.0582C461.045 44.2976 446.452 45.1455 433.229 50.6044C417.525 57.0877 405.039 69.5439 398.519 85.2328C391.999 100.922 391.978 118.558 398.462 134.262C403.921 147.485 413.614 158.426 425.906 165.446C429.747 167.639 431.714 172.283 430.017 176.367Z",
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-3-outside-1_3686_27150)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-2_3686_27150",
    maskUnits: "userSpaceOnUse",
    x: 349.078,
    y: 34.6001,
    width: 130.228,
    height: 153.434,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 349.078,
    y: 34.6001,
    width: 130.228,
    height: 153.434
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.017 176.363C428.32 180.447 423.609 182.416 419.715 180.32C409.204 174.661 400.06 166.706 392.985 157.008C384.332 145.147 379.106 131.135 377.879 116.505C376.652 101.874 379.471 87.1874 386.029 74.0509C391.39 63.3099 399.082 53.9432 408.503 46.6131C411.994 43.8974 416.967 45.055 419.32 48.7992C421.674 52.5433 420.507 57.4502 417.086 60.2523C410.118 65.9589 404.407 73.0912 400.358 81.2034C395.112 91.7126 392.857 103.462 393.838 115.166C394.82 126.871 399 138.08 405.923 147.569C411.267 154.894 418.085 160.975 425.907 165.442C429.747 167.635 431.714 172.279 430.017 176.363Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M430.017 176.363C428.32 180.447 423.609 182.416 419.715 180.32C409.204 174.661 400.06 166.706 392.985 157.008C384.332 145.147 379.106 131.135 377.879 116.505C376.652 101.874 379.471 87.1874 386.029 74.0509C391.39 63.3099 399.082 53.9432 408.503 46.6131C411.994 43.8974 416.967 45.055 419.32 48.7992C421.674 52.5433 420.507 57.4502 417.086 60.2523C410.118 65.9589 404.407 73.0912 400.358 81.2034C395.112 91.7126 392.857 103.462 393.838 115.166C394.82 126.871 399 138.08 405.923 147.569C411.267 154.894 418.085 160.975 425.907 165.442C429.747 167.635 431.714 172.279 430.017 176.363Z",
    fill: "#9C44C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.017 176.363C428.32 180.447 423.609 182.416 419.715 180.32C409.204 174.661 400.06 166.706 392.985 157.008C384.332 145.147 379.106 131.135 377.879 116.505C376.652 101.874 379.471 87.1874 386.029 74.0509C391.39 63.3099 399.082 53.9432 408.503 46.6131C411.994 43.8974 416.967 45.055 419.32 48.7992C421.674 52.5433 420.507 57.4502 417.086 60.2523C410.118 65.9589 404.407 73.0912 400.358 81.2034C395.112 91.7126 392.857 103.462 393.838 115.166C394.82 126.871 399 138.08 405.923 147.569C411.267 154.894 418.085 160.975 425.907 165.442C429.747 167.635 431.714 172.279 430.017 176.363Z",
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-4-outside-2_3686_27150)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-3_3686_27150",
    maskUnits: "userSpaceOnUse",
    x: 350.002,
    y: 81.1468,
    width: 110.116,
    height: 106.878,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 350.002,
    y: 81.1468,
    width: 110.116,
    height: 106.878
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.017 176.354C428.32 180.438 423.609 182.408 419.715 180.311C404.644 172.198 392.501 159.426 385.174 143.802C377.848 128.178 375.794 110.675 379.194 93.9001C380.073 89.5658 384.599 87.2035 388.824 88.5103C393.049 89.817 395.362 94.2996 394.592 98.6545C392.305 111.592 394.042 124.991 399.674 137.003C405.307 149.014 414.498 158.918 425.906 165.433C429.747 167.626 431.714 172.271 430.017 176.354Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M430.017 176.354C428.32 180.438 423.609 182.408 419.715 180.311C404.644 172.198 392.501 159.426 385.174 143.802C377.848 128.178 375.794 110.675 379.194 93.9001C380.073 89.5658 384.599 87.2035 388.824 88.5103C393.049 89.817 395.362 94.2996 394.592 98.6545C392.305 111.592 394.042 124.991 399.674 137.003C405.307 149.014 414.498 158.918 425.906 165.433C429.747 167.626 431.714 172.271 430.017 176.354Z",
    fill: "#9C44C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.017 176.354C428.32 180.438 423.609 182.408 419.715 180.311C404.644 172.198 392.501 159.426 385.174 143.802C377.848 128.178 375.794 110.675 379.194 93.9001C380.073 89.5658 384.599 87.2035 388.824 88.5103C393.049 89.817 395.362 94.2996 394.592 98.6545C392.305 111.592 394.042 124.991 399.674 137.003C405.307 149.014 414.498 158.918 425.906 165.433C429.747 167.626 431.714 172.271 430.017 176.354Z",
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-5-outside-3_3686_27150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.785 104.143C465.785 109.299 463.729 114.243 460.071 117.889C456.413 121.534 451.451 123.582 446.277 123.582C441.104 123.582 436.142 121.534 432.484 117.889C428.825 114.243 426.77 109.299 426.77 104.143C426.77 98.9878 428.825 94.0435 432.484 90.398C436.142 86.7525 441.104 84.7045 446.277 84.7045C451.451 84.7045 456.413 86.7525 460.071 90.398C463.729 94.0435 465.785 98.9878 465.785 104.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.327 100.806L443.623 110.526C443.248 110.838 442.77 110.999 442.283 110.977C441.796 110.956 441.334 110.753 440.99 110.409L437.088 106.521C436.725 106.154 436.522 105.659 436.523 105.143C436.525 104.628 436.731 104.134 437.097 103.769C437.463 103.405 437.958 103.2 438.476 103.198C438.993 103.196 439.49 103.398 439.858 103.76L442.491 106.404L452.831 97.8123C453.027 97.6434 453.255 97.5152 453.502 97.4352C453.749 97.3552 454.009 97.325 454.268 97.3464C454.526 97.3678 454.778 97.4403 455.008 97.5598C455.239 97.6792 455.443 97.8431 455.608 98.042C455.774 98.2409 455.899 98.4707 455.974 98.718C456.05 98.9653 456.076 99.2252 456.049 99.4825C456.023 99.7398 455.946 99.9893 455.822 100.216C455.698 100.444 455.53 100.645 455.327 100.806Z",
    fill: "#9C44C0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_3686_27150_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.199951 5C0.199951 2.23857 2.43853 0 5.19995 0H478.2C480.961 0 483.2 2.23858 483.2 5V135C483.2 137.761 480.961 140 478.2 140H5.19995C2.43852 140 0.199951 137.761 0.199951 135V5Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertStatusAgileOr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alertStatus_agileOr.5104cb19dc1c70966bae4029fac4e3b6.svg";